import { render, staticRenderFns } from "./VueNestableHandle.vue?vue&type=template&id=55e2f2f8&"
import script from "./VueNestableHandle.vue?vue&type=script&lang=js&"
export * from "./VueNestableHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../exo_admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports